import React, { memo } from 'react';

const Skeleton = memo(function Skeleton({ width = '100%', height = '1rem', radius = '6px', style }) {
  return (
    <div className="skeleton" style={{ width, height, borderRadius: radius, ...style }} />
  );
});

export function SkeletonCard({ linhas = 3 }) {
  return (
    <div className="card">
      <Skeleton width="40%" height="1.1rem" style={{ marginBottom: '1.25rem' }} />
      {Array.from({ length: linhas }).map((_, i) => (
        <div key={i} style={{ display: 'flex', gap: '0.75rem', marginBottom: '0.75rem', alignItems: 'center' }}>
          <Skeleton width="60%" height="0.85rem" />
          <Skeleton width="25%" height="0.85rem" />
        </div>
      ))}
    </div>
  );
}

export function SkeletonLista({ itens = 4 }) {
  return (
    <div>
      {Array.from({ length: itens }).map((_, i) => (
        <div key={i} className="item-card" style={{ marginBottom: '0.75rem' }}>
          <div className="item-card-body">
            <Skeleton width="35%" height="0.9rem" />
            <Skeleton width="20%" height="0.75rem" />
            <Skeleton width="15%" height="0.75rem" />
          </div>
        </div>
      ))}
    </div>
  );
}

export default Skeleton;
